import axios from 'axios';
import Cookies from 'js-cookie'
import _ from 'lodash'
import { Notification } from 'element-ui';

import NProgress from 'nprogress'
import 'nprogress/nprogress.css'

import router from '@/router/index'

const handleRequestError = _.throttle((msg, statusCode) => {
  Notification({
    title: statusCode ? '错误码 ' + statusCode : 'ERROR',
    message: msg || 'Error',
    type: 'error',
    duration: 2000,
  });
}, 3000);

const service = axios.create({
  timeout: 1000 * 12,
  baseURL: 'https://api.vrbook.vip'
});

service.interceptors.request.use(
  config => {
    NProgress.start()
    config.headers.Authorization = Cookies.get('token')
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    NProgress.done()
    const res = response.data
    const { msg, statusCode } = res
    if (statusCode === 200) {
      return res
    } else {
      if (statusCode == 600) {
        const vipKey = Cookies.get('vipKey')
        Cookies.remove('token')
        Cookies.remove(vipKey)
        Cookies.remove('vipKey')
        router.push('/login')
      }
      handleRequestError(msg, statusCode)
      return Promise.reject(new Error(msg || 'Error'))
    }
  },
  error => {
    handleRequestError(error.message)
    NProgress.done();
    return Promise.reject(error)
  }
)

export default service;